// extracted by mini-css-extract-plugin
export default {"title":"Page404_title__o53zN","subtitle":"Page404_subtitle__4CHqq","container":"Page404_container__pRf8I"};